type CardProps = {
  title: string
  detail: string
  icon: string
}
export const Card = ({ title, detail, icon }: CardProps) => {
  return (
    <div className="flex w-full max-w-[265px] shrink-0 items-center gap-x-[16px] rounded-[12px] bg-[#D9C7B0] px-[23px] py-[44px]  lg:h-full lg:w-[30%] lg:min-w-[30%] lg:max-w-max">
      <div className="flex size-[50px] shrink-0 items-center justify-center rounded-[50%] bg-white">
        <img src={icon} className="h-[20px] w-[22px]" />
      </div>
      <div className="w-full break-all">
        <h2 className="font-nunito  text-[16px] font-bold leading-[25.6px] text-[#333333] md:text-[20px] md:leading-[32px] lg:text-[24px] lg:leading-[38.4px] ">
          {title}
        </h2>
        <p className="font-nunito text-[12px] font-normal leading-[19.2px] text-[#333333] md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px]">
          {detail}
        </p>
      </div>
    </div>
  )
}
